import script from "./Retention.vue?vue&type=script&setup=true&lang=js"
export * from "./Retention.vue?vue&type=script&setup=true&lang=js"

import "./Retention.vue?vue&type=style&index=0&id=200e8ef9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200e8ef9"]])

export default __exports__